import React from 'react';
import { CardIcon } from '@trello/nachos/icons/card';

import styles from './CardBackHeader.less';

interface CardBackHeaderProps {
  boardName: string;
  cardName: string;
  listName: string;
}

export const CardBackHeader = ({
  boardName,
  cardName,
  listName,
}: CardBackHeaderProps) => (
  <div className={styles.header}>
    <div className={styles.cardIcon}>
      <CardIcon size="large" />
    </div>
    <div className={styles.dialogTitle}>
      <h2 className={styles.cardName} dir="auto">
        {cardName}
      </h2>
    </div>
    <div className={styles.cardLocation}>
      in list {listName} on board {boardName}
    </div>
  </div>
);
